import { createContext, h, ComponentChildren } from "preact";
import { useState } from "preact/hooks";
import { ParsedSettings } from "../types/settings";

type SettingsContextType = {
  settings: ParsedSettings;
  rootEl?: Element;
};

type SettingsProviderProps = {
  children: ComponentChildren;
  initialSettings: ParsedSettings;
  appRoot: Element;
};

// We construct a basic initial shape to guarantee types,
// since we know the entire app is underneath this context.
const initialState: SettingsContextType = {
  settings: {
    accessId: "",
    inIframe: false,
    platform: "",
    theme: "auto",
    layout: "stacked",
    playAs: "infer",
    showDownload: false,
    showAd: false,
    showLanguageDropdown: false,
    showTranscript: false,
  },
};

const SettingsContext = createContext<SettingsContextType>(initialState);

function SettingsProvider({
  initialSettings,
  appRoot,
  children,
}: SettingsProviderProps) {
  // pass in initial settings from window
  const [settings] = useState<ParsedSettings>(initialSettings);

  // TODO: grab settings from localStorage
  return (
    <SettingsContext.Provider value={{ settings, rootEl: appRoot }}>
      {children}
    </SettingsContext.Provider>
  );
}

export { SettingsProvider };
export default SettingsContext;
